// extracted by mini-css-extract-plugin
export default {"card":"O0-z","carouselContainer":"P0-z","carouselContent":"Q0-z"};